__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-ads/v3_1_2/";